import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { useLandingContent } from '../useLandingContent';

export default function Footer() {
  const { content } = useLandingContent();
  const company = content.company;
  return (
    <footer className="bg-black text-stone-400 py-12 sm:py-16" data-testid="landing-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10 pb-10 border-b border-stone-900">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/edilcima_logo.png" alt="EDIL CIMA S.R.L." className="w-10 h-10 rounded object-contain bg-slate-900 p-0.5" />
              <div>
                <p className="font-black text-white text-base tracking-tight">EDIL CIMA S.R.L.</p>
                <p className="text-[10px] text-primary uppercase tracking-widest">Impresa edile dal {company.foundingYear}</p>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md mb-4">
              Impresa edile a Calcinato (Brescia) specializzata in nuove costruzioni, ristrutturazioni, tetti, piscine e manutenzioni. Lavori certificati a regola d'arte.
            </p>
            <Link to="/app/login" data-testid="footer-login"
              className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary text-white text-sm font-bold rounded-md hover:bg-primary transition-colors">
              <LogIn size={14} /> Login Gestionale
            </Link>
          </div>

          {/* Servizi */}
          <div>
            <p className="text-[10px] font-black text-white uppercase tracking-widest mb-3">Servizi</p>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary">Nuove Costruzioni</button></li>
              <li><button onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary">Ristrutturazioni</button></li>
              <li><button onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary">Rifacimento Tetti</button></li>
              <li><button onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary">Piscine</button></li>
              <li><button onClick={() => document.getElementById('servizi')?.scrollIntoView({ behavior: 'smooth' })} className="hover:text-primary">Manutenzioni</button></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <p className="text-[10px] font-black text-white uppercase tracking-widest mb-3">Contatti</p>
            <ul className="space-y-2 text-sm">
              <li className="text-white font-bold">{company.address.street}</li>
              <li>{company.address.cap} {company.address.city} ({company.address.province})</li>
              <li className="pt-1"><a href={`tel:${company.phoneFisso.replace(/\s/g, '')}`} className="hover:text-primary">{company.phoneFisso}</a></li>
              <li><a href={`mailto:${company.email}`} className="hover:text-primary break-all">{company.email}</a></li>
              <li><a href={`mailto:${company.pec}`} className="hover:text-primary break-all">{company.pec}</a></li>
            </ul>
          </div>
        </div>

        {/* Legal */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs">
          <p>
            © {new Date().getFullYear()} <strong className="text-white">{company.legalName}</strong> · P.IVA / C.F. {company.vat} · Codice SDI {company.sdiCode}
          </p>
          <p className="text-stone-500">Sito ottimizzato SEO &amp; GEO · Made with care.</p>
        </div>
      </div>
    </footer>
  );
}
